import { render } from "./sight-sound.vue?vue&type=template&id=4f0af017&scoped=true"
import script from "./sight-sound.vue?vue&type=script&lang=js"
export * from "./sight-sound.vue?vue&type=script&lang=js"

import "./sight-sound.vue?vue&type=style&index=0&id=4f0af017&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0af017"]])

export default __exports__